import { apiGet, apiPost } from "../../utils"

export function getPromotionsAdminAPI(data) {
    return apiGet(`/api/getPromotionsAdmin`, data)
}